import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { PapiDeviation } from '@wix/da-papi-types';
import { editDeviation } from '@wix/da-shared-react/pkg/redux/deviations/actionCreators';
import { getCurrentUserId } from '@wix/da-shared-react/pkg/publicSession/selectors';
import TierPromotionCardDumb from '@wix/da-shared-react/pkg/DeviationViews/TierPromotionCardDumb';
import TierProductCardDumb from '@wix/da-shared-react/pkg/DeviationViews/TierProductCardDumb';
import Slider from '@wix/da-shared-react/pkg/Slider';
import AddTierCard from './AddTierCard';

import s from './Tiers.scss';

export interface Props {
  moduleId: number;
  tiers: PapiDeviation[];
  seeAllUrl?: string;
  isOwner: boolean;
  view?: 'promotion' | 'product';
}

const tierDeviationToPromotionCardProps = (tierDeviation: PapiDeviation) => {
  const { title = '', tier, coverImage, extended, author } = tierDeviation;
  const { description = '' } = extended || {};
  const {
    benefits = [],
    dollarPrice: formattedPrice,
    stats: { subscribers: numSubscribers = 0 } = {},
  } = tier || {};
  // Fields missing from the API
  return {
    title,
    description,
    author,
    benefits,
    coverImage,
    numSubscribers,
    formattedPrice,
  };
};

const Tiers: React.FC<Props> = ({ tiers, isOwner, view = 'promotion' }) => {
  const dispatch = useDispatch();
  const editTier = useCallback(
    deviation => dispatch(editDeviation({ deviation })),
    [dispatch]
  );
  const currentUserId = useSelector(state => getCurrentUserId(state));
  const canEditTier = useCallback(
    deviation => deviation?.author?.userId === currentUserId,
    [currentUserId]
  );
  const subscribeToTier = useCallback(tier => {}, []);
  const count = tiers.length;

  return (
    <Slider className={classnames(s['slider'], s[view])} scrollBy={0.5}>
      {isOwner && <AddTierCard count={count} />}
      {tiers.map(tier => (
        <>
          {view === 'promotion' && (
            <TierPromotionCardDumb
              key={tier.deviationId}
              {...tierDeviationToPromotionCardProps(tier)}
              ctaButton={canEditTier(tier) ? 'edit' : 'subscribe'}
              onCTAClick={
                canEditTier(tier)
                  ? () => editTier(tier)
                  : () => subscribeToTier(tier)
              }
              width={360}
            />
          )}
          {view === 'product' && (
            <TierProductCardDumb
              key={tier.deviationId}
              {...tierDeviationToPromotionCardProps(tier)}
              ctaButton={canEditTier(tier) ? 'edit' : 'subscribe'}
              onCTAClick={
                canEditTier(tier)
                  ? () => editTier(tier)
                  : () => subscribeToTier(tier)
              }
              withExpandButton
            />
          )}
        </>
      ))}
    </Slider>
  );
};
Tiers.displayName = 'Tiers';

export default Tiers;
